import * as React from "react";
import styled, { css } from "styled-components";
import { Grid } from "components/bootstrap";
import usePermittedAlertsEventsStreams from "components/welcome/hooks/usePermittedAlertsEventsStreams";
import HeatmapWidget from "./HeatmapWidget";
import WelcomeEventsHistogram, { WIDGET_HEIGHT } from "./WelcomeEventsHistogram";
import { widgetGap } from "../Constants";
const Container = styled.div(
  ({ theme }) => css`
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    align-items: stretch;
    gap: ${widgetGap(theme)};

    @media (max-width: ${theme.breakpoints.max.md}) {
      grid-auto-flow: row;
    }
  `
);
const HistogramWrapper = styled.div(
  ({ theme }) => css`
    min-width: 0;
    max-height: ${WIDGET_HEIGHT};

    @media (max-width: ${theme.breakpoints.max.md}) {
      max-height: none;
    }
  `
);
const HeatmapWrapper = styled(Grid)`
  min-width: 0;
  width: 100%;
`;
const ChartsRow = () => {
  const permittedAlertsEventsStreams = usePermittedAlertsEventsStreams();
  return /* @__PURE__ */ React.createElement(Container, null, permittedAlertsEventsStreams.length > 0 && /* @__PURE__ */ React.createElement(HistogramWrapper, null, /* @__PURE__ */ React.createElement(WelcomeEventsHistogram, null)), /* @__PURE__ */ React.createElement(HeatmapWrapper, null, /* @__PURE__ */ React.createElement(HeatmapWidget, null)));
};
export default ChartsRow;
